import React from 'react';
import './CouponSearchBar.css';

const CouponSearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="coupon-search-bar">
      <div className="search-input-wrapper">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search coupons by code..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CouponSearchBar;

